<template>
  <div>
    <div class="contentBox w">
      <div class="contentStitle">Internships enable employment</div>
      <div class="contentTitle">实习赋能就业</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="yjh_item">
        <div class="yjh_item_img">
          <img :src="src.qyfw" alt srcset />
        </div>
        <div class="yjh_item_text text_right">
          <div class="text_box">
            <div class="text_line"></div>
            <div class="text_title">实习赋能就业简介！</div>
          </div>
          <div class="text_content">
            云久鸿作为多家世界500强的人才资源合作商，对当下各个工作领域的技能需求十分了解。同时又与多家职业技能院校合作，建立了人才培养发展的平台，全力满足企业的人才需求，帮助广大应届毕业生们打通就业通道。
          </div>
          <div class="text_otal">
            优势：帮助实习人员提高工作能力，积累工作经验；为企业储备人才，为企业提供新鲜血液和发展动力。
          </div>
        </div>
      </div>
    </div>
    <div class="mobile_contentBox">
      <div class="contentTitle noStitle">实习赋能就业</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="mobile_yjh_item">
        <div class="mobile_yjh_item_text">
          <div class="text_line"></div>
          <div class="text_title">实习赋能就业简介！</div>
        </div>
        <div class="mobile_yjh_item_content">
          云久鸿作为多家世界500强的人才资源合作商，对当下各个工作领域的技能需求十分了解。同时又与多家职业技能院校合作，建立了人才培养发展的平台，全力满足企业的人才需求，帮助广大应届毕业生们打通就业通道。
        </div>
        <div class="mobile_yjh_item_otal">
          优势：帮助实习人员提高工作能力，积累工作经验；为企业储备人才，为企业提供新鲜血液和发展动力。
        </div>

        <div class="mobile_yjh_item_img">
          <img :src="src.qyfw" alt srcset />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import src from "../../../utils/assets";
export default {
  data() {
    return {
      src: src,
    };
  },
};
</script>

<style lang="less" scoped></style>
